module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web6.08d4da16.png";